import { useLayoutEffect } from 'react';

import { fetchPricePerClick } from 'components/CpcFlexibleCreate/CpcForm/AdRegions/PricePerClickLabel/fetchPricePerClick';

import { PriceType, selectCampaignRegions } from 'store/models/createCampaign';
import { useDispatch, useSelector } from 'store/utils';

interface UseGetPricePerClick {
    priceType: PriceType;
    pricePerClick: number;
}

export const useGetPricePerClick = (): UseGetPricePerClick => {
    const pricePerClick = useSelector((state) => state.createCampaign.pricePerClick);
    const priceType = useSelector((state) => state.createCampaign.priceType);
    const adRegions = useSelector(selectCampaignRegions);
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        void dispatch(fetchPricePerClick());
    }, [adRegions, dispatch]);

    return { priceType, pricePerClick };
};
